import { Response, ViewManagerView } from '../../viewManagerTypes';

export abstract class ViewApi<TView> {
    abstract urlPath: string;
    
    async getViews(viewName: string): Promise<ViewManagerView[]> {
        const response = await fetch(`${this.urlPath}/by-name/${viewName}`);
        if (response.ok) {
            const record: Response<ViewManagerView[]> = await response.json();
            return record.data;
        } else {
            throw new Error(`An error occurred ${response.status}`);
        }
    }
    async getView(viewId: string): Promise<TView> {
        const response = await fetch(`${this.urlPath}/by-id/${viewId}`);
        if (response.ok) {
            const record: Response<TView> = await response.json();
            return record.data;
        } else {
            throw new Error(`An error occurred ${response.status}`);
        }
    }
    async saveView(gridView: TView): Promise<string> {
        const response = await fetch(`${this.urlPath}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(gridView),
        });
        if (response.ok) {
            const record: any = await response.json();
            return record.Id;
        } else {
            throw new Error(`An error occurred ${response.status}`);
        }
    }
    async updateViewName(viewId: string, viewName: string): Promise<void> {
        const response = await fetch(`${this.urlPath}/${viewId}/name/${viewName}`, {
            method: 'PUT',
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
    }
    async updateView(viewId: string, gridView: TView): Promise<void> {
        const response = await fetch(`${this.urlPath}/${viewId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(gridView),
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    }
    async setViewPrivate(viewId: string, isPrivate: boolean): Promise<void> {
        const response = await fetch(`${this.urlPath}/${viewId}/private/${isPrivate}`, {
            method: 'PUT',
        });
        
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
    }
    async deleteView(viewId: string): Promise<void> {
        const response = await fetch(`${this.urlPath}/${viewId}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
    }
}